import { trpc } from '../lib/trpc';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PRODUCTS = [
  {
    id: 'zhixiaoke',
    name: '智小客',
    tagline: 'AI客服机器人',
    description: '多渠道接入（微信/网站），7×24小时自动回复，FAQ智能分流，订单查询一键完成。',
    price: '2,980',
    unit: '元/月',
    features: ['微信/网站双渠道', 'FAQ智能回复', '订单查询自动化', '人工接管无缝切换', '数据报表分析'],
    highlight: false,
    emoji: '💬',
    color: 'bg-blue-500',
  },
  {
    id: 'xiaoxiaobang',
    name: '销小帮',
    tagline: 'AI销售助手',
    description: '客户画像分析，智能话术推荐，商机构建与跟进提醒，助力销售团队高效成单。',
    price: '5,800',
    unit: '元/月',
    features: ['客户画像分析', 'AI话术推荐', '商机跟进提醒', '销售数据看板', '竞品对比分析'],
    highlight: true,
    emoji: '📈',
    color: 'bg-purple-500',
  },
  {
    id: 'banxiaozhu',
    name: '办小助',
    tagline: 'AI办公助理',
    description: '会议纪要自动生成，审批流程自动化，报表智能整理，大幅提升内部协作效率。',
    price: '3,800',
    unit: '元/月',
    features: ['会议纪要生成', '审批流自动化', '报表智能整理', '任务分配提醒', '知识库检索'],
    highlight: false,
    emoji: '📋',
    color: 'bg-green-500',
  },
  {
    id: 'custom',
    name: '全定制',
    tagline: 'AI Agent定制服务',
    description: '根据企业特殊需求，深度定制AI Agent，含行业知识库微调、私有化部署、全流程开发。',
    price: '30,000+',
    unit: '元起',
    features: ['行业知识库搭建', '私有化部署', '深度定制开发', '年度维保服务', '专属客户成功经理'],
    highlight: false,
    emoji: '🚀',
    color: 'bg-orange-500',
  },
];

const STEPS = [
  {
    step: '01',
    title: '描述业务需求',
    description: '告诉我们您的业务场景和痛点，我们的产品顾问将在24小时内为您提供方案。',
  },
  {
    step: '02',
    title: 'AI定制开发',
    description: '基于您的行业知识库和数据，深度定制专属AI Agent，无需任何技术背景。',
  },
  {
    step: '03',
    title: '快速上线运营',
    description: '接入您的现有系统，1周内完成部署，即刻享受AI带来的效率提升。',
  },
];

const FAQS = [
  {
    q: '我们公司没有技术团队，能用吗？',
    a: '完全可以。智纬AI平台设计为零代码操作，从创建到部署全程可视化，您只需描述需求，我们来完成其余工作。',
  },
  {
    q: '数据安全如何保障？',
    a: '我们支持公有云和私有化部署两种模式。所有数据传输采用TLS加密，私有化部署确保数据不出您的服务器。',
  },
  {
    q: '可以先试用吗？',
    a: '可以。我们提供首月5折体验价，以及15天免费演示期，您可以充分体验后再做决定。',
  },
  {
    q: '合同周期是多久？',
    a: '主要产品支持月付和年付两种方式，年付享85折优惠。定制服务按项目签订年度维保合同。',
  },
];

export function MarketingPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', company: '', phone: '', need: '' });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    void trpc.lead.create.mutate(formData).catch((err: unknown) => { console.error(err); alert('提交失败，请稍后重试'); });
  };

  return (
    <div className="min-w-0">
      {/* Navbar */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">智</span>
              </div>
              <span className="text-xl font-bold text-gray-900">智纬AI</span>
              <span className="text-gray-400 text-sm ml-1 hidden sm:inline">westilt.com</span>
            </div>
            <div className="hidden md:flex items-center gap-8">
              <a href="#products" className="text-gray-600 hover:text-gray-900 text-sm font-medium">产品</a>
              <Link to="/pricing" className="text-gray-600 hover:text-gray-900 text-sm font-medium">定价</Link>
              <a href="#how" className="text-gray-600 hover:text-gray-900 text-sm font-medium">如何使用</a>
              <a href="#faq" className="text-gray-600 hover:text-gray-900 text-sm font-medium">常见问题</a>
              <a href="#contact" className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition">
                免费预约演示
              </a>
            </div>
            <button
              className="md:hidden p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 py-4 flex flex-col gap-3">
            <a href="#products" className="text-gray-600 py-2" onClick={() => setMobileMenuOpen(false)}>产品</a>
            <a href="#pricing" className="text-gray-600 py-2" onClick={() => setMobileMenuOpen(false)}>定价</a>
            <a href="#how" className="text-gray-600 py-2" onClick={() => setMobileMenuOpen(false)}>如何使用</a>
            <a href="#faq" className="text-gray-600 py-2" onClick={() => setMobileMenuOpen(false)}>常见问题</a>
            <a href="#contact" className="px-4 py-2 bg-blue-600 text-white rounded-lg text-center font-medium" onClick={() => setMobileMenuOpen(false)}>免费预约演示</a>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-purple-50 pt-20 pb-28 overflow-hidden">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" />
          <div className="absolute top-20 right-10 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-blue-100 text-blue-700 rounded-full text-sm font-medium mb-8">
            <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
            AI普及浪潮中，中小企业的新机遇
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            为中小企业<br className="hidden sm:block" />
            <span className="text-blue-600">定制专属AI团队</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto mb-10">
            智纬AI帮助中国中小企业用AI Agent实现客服、销售、办公自动化。<br />
            无需技术背景，1周内上线，效果可量化。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#contact"
              className="px-8 py-4 bg-blue-600 text-white rounded-xl text-lg font-semibold hover:bg-blue-700 transition shadow-lg shadow-blue-200"
            >
              免费预约产品演示
            </a>
            <a
              href="#products"
              className="px-8 py-4 bg-white text-gray-700 rounded-xl text-lg font-semibold hover:bg-gray-50 transition border border-gray-200"
            >
              了解更多 →
            </a>
          </div>
          <p className="mt-6 text-gray-400 text-sm">已有 <strong className="text-gray-600">200+</strong> 中小企业正在使用 · 首月体验5折</p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-white border-y border-gray-100 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {[
              { value: '200+', label: '服务企业客户' },
              { value: '85%', label: '客服效率提升' },
              { value: '60%', label: '人力成本节约' },
              { value: '7天', label: '平均上线周期' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
                <div className="text-sm text-gray-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section id="products" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">四款产品，覆盖企业核心场景</h2>
            <p className="text-gray-600 max-w-xl mx-auto">从智能客服到销售助手，从办公自动化到全定制开发，找到最适合您的AI解决方案</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {PRODUCTS.map((product) => (
              <div
                key={product.id}
                className={`rounded-2xl p-6 flex flex-col transition hover:shadow-xl hover:-translate-y-1 ${
                  product.highlight
                    ? 'bg-gradient-to-br from-purple-600 to-blue-600 text-white shadow-xl shadow-purple-200'
                    : 'bg-white border border-gray-200 shadow-sm'
                }`}
              >
                <div className={`w-12 h-12 ${product.highlight ? 'bg-white/20' : product.color} rounded-xl flex items-center justify-center text-2xl mb-4`}>
                  {product.emoji}
                </div>
                <h3 className={`text-xl font-bold mb-1 ${product.highlight ? 'text-white' : 'text-gray-900'}`}>
                  {product.name}
                </h3>
                <p className={`text-sm font-medium mb-3 ${product.highlight ? 'text-purple-100' : 'text-gray-500'}`}>
                  {product.tagline}
                </p>
                <p className={`text-sm mb-5 flex-grow ${product.highlight ? 'text-purple-100' : 'text-gray-600'}`}>
                  {product.description}
                </p>
                <div className={`text-2xl font-bold mb-1 ${product.highlight ? 'text-white' : 'text-gray-900'}`}>
                  ¥{product.price}
                  <span className={`text-sm font-normal ${product.highlight ? 'text-purple-200' : 'text-gray-400'}`}> {product.unit}</span>
                </div>
                <ul className="space-y-2 mb-6">
                  {product.features.map((f) => (
                    <li key={f} className={`flex items-center gap-2 text-sm ${product.highlight ? 'text-purple-100' : 'text-gray-600'}`}>
                      <svg className={`w-4 h-4 flex-shrink-0 ${product.highlight ? 'text-white' : 'text-green-500'}`} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to={`/product/${product.id}`}
                  className={`mt-auto w-full py-2.5 rounded-lg text-center text-sm font-semibold transition ${
                    product.highlight
                      ? 'bg-white text-purple-600 hover:bg-purple-50'
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  立即咨询
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="how" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">三步，开启AI转型</h2>
            <p className="text-gray-600">从需求到上线，无需任何技术背景</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {STEPS.map((step, i) => (
              <div key={step.step} className="relative text-center">
                <div className="text-7xl font-bold text-gray-100 mb-4">{step.step}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                {i < STEPS.length - 1 && (
                  <div className="hidden md:block absolute top-8 right-0 translate-x-1/2 text-gray-300">
                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">简单透明的定价</h2>
            <p className="text-gray-600">月付降低门槛，年付享85折优惠</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              {
                name: '智小客',
                subtitle: 'AI客服机器人',
                price: '2,980',
                description: '适合：有客服需求但缺乏人工的零售、餐饮、服务类商户',
                features: ['微信/网站双渠道接入', 'FAQ智能回复', '订单查询自动化', '月数据报表', '基础人工接管'],
                cta: '咨询智小客',
              },
              {
                name: '销小帮',
                subtitle: 'AI销售助手',
                price: '5,800',
                description: '适合：B2B销售团队、外贸、电商等以获客为核心的业务',
                features: ['客户画像分析', 'AI话术推荐引擎', '商机跟进提醒', '销售漏斗看板', '竞品分析工具'],
                highlight: true,
                cta: '咨询销小帮',
              },
              {
                name: '办小助',
                subtitle: 'AI办公助理',
                price: '3,800',
                description: '适合：内部流程繁琐、协作效率低的中小企业',
                features: ['会议纪要自动生成', '审批流自动化', '报表智能整理', '任务分配提醒', '企业知识库检索'],
                cta: '咨询办小助',
              },
            ].map((plan) => (
              <div
                key={plan.name}
                className={`rounded-2xl p-8 flex flex-col ${
                  plan.highlight
                    ? 'bg-gray-900 text-white shadow-2xl scale-105'
                    : 'bg-white border border-gray-200 shadow-sm'
                }`}
              >
                {plan.highlight && (
                  <div className="inline-flex items-center gap-1 text-xs font-semibold text-yellow-400 mb-3">
                    <span>★</span> 最受欢迎
                  </div>
                )}
                <h3 className={`text-xl font-bold ${plan.highlight ? 'text-white' : 'text-gray-900'}`}>{plan.name}</h3>
                <p className={`text-sm mb-4 ${plan.highlight ? 'text-gray-400' : 'text-gray-500'}`}>{plan.subtitle}</p>
                <div className="mb-1">
                  <span className={`text-4xl font-bold ${plan.highlight ? 'text-white' : 'text-gray-900'}`}>¥{plan.price}</span>
                  <span className={`text-sm ${plan.highlight ? 'text-gray-400' : 'text-gray-400'}`}>/月</span>
                </div>
                <p className={`text-xs mb-6 ${plan.highlight ? 'text-gray-400' : 'text-gray-500'}`}>年付85折，折合 ¥{Math.round(Number(plan.price) * 12 * 0.85).toLocaleString()}/年</p>
                <p className={`text-sm mb-6 ${plan.highlight ? 'text-gray-300' : 'text-gray-600'}`}>{plan.description}</p>
                <ul className="space-y-3 mb-8 flex-grow">
                  {plan.features.map((f) => (
                    <li key={f} className={`flex items-start gap-2 text-sm ${plan.highlight ? 'text-gray-200' : 'text-gray-600'}`}>
                      <svg className={`w-4 h-4 mt-0.5 flex-shrink-0 ${plan.highlight ? 'text-blue-400' : 'text-green-500'}`} fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className={`w-full py-3 rounded-xl text-center font-semibold transition ${
                    plan.highlight
                      ? 'bg-blue-500 text-white hover:bg-blue-400'
                      : 'bg-gray-900 text-white hover:bg-gray-800'
                  }`}
                >
                  {plan.cta}
                </a>
              </div>
            ))}
          </div>
          <p className="text-center text-gray-500 text-sm mt-8">
            全定制服务（行业Agent/私有化部署）：¥30,000起 ·{' '}
            <a href="#contact" className="text-blue-600 hover:underline">联系商务洽谈</a>
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">常见问题</h2>
          </div>
          <div className="space-y-3">
            {FAQS.map((faq, i) => (
              <div key={i} className="border border-gray-200 rounded-xl overflow-hidden">
                <button
                  className="w-full text-left px-6 py-4 flex justify-between items-center gap-4 bg-white hover:bg-gray-50 transition"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span className="font-medium text-gray-900">{faq.q}</span>
                  <svg
                    className={`w-5 h-5 text-gray-400 flex-shrink-0 transition-transform ${openFaq === i ? 'rotate-180' : ''}`}
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {openFaq === i && (
                  <div className="px-6 pb-4 text-gray-600 text-sm leading-relaxed">{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact / CTA */}
      <section id="contact" className="py-20 bg-gradient-to-br from-blue-600 to-purple-700">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <h2 className="text-3xl sm:text-4xl font-bold mb-4">准备好开始了吗？</h2>
              <p className="text-blue-100 mb-6 leading-relaxed">
                预约免费产品演示，体验AI Agent如何为您的企业降本增效。我们的顾问将在24小时内与您联系。
              </p>
              <div className="space-y-3 text-blue-100 text-sm">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-blue-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  无需技术背景，1周内上线
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-blue-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  首月体验5折优惠
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-blue-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  7×24小时客户成功支持
                </div>
              </div>
            </div>
            <div>
              {formSubmitted ? (
                <div className="bg-white rounded-2xl p-8 text-center shadow-xl">
                  <div className="text-5xl mb-4">🎉</div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">预约成功！</h3>
                  <p className="text-gray-600 text-sm">我们的顾问将在 <strong>24小时</strong> 内联系您，请保持电话畅通。</p>
                </div>
              ) : (
                <form onSubmit={handleFormSubmit} className="bg-white rounded-2xl p-8 shadow-xl space-y-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">预约免费演示</h3>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">您的姓名 *</label>
                    <input
                      required
                      type="text"
                      placeholder="张三"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">公司名称 *</label>
                    <input
                      required
                      type="text"
                      placeholder="示例科技有限公司"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      value={formData.company}
                      onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">联系电话 *</label>
                    <input
                      required
                      type="tel"
                      placeholder="138-0000-0000"
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">您希望解决的问题</label>
                    <textarea
                      rows={3}
                      placeholder="例如：我们每天有200+客服消息，希望能用AI自动回复常见问题..."
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none"
                      value={formData.need}
                      onChange={(e) => setFormData({ ...formData, need: e.target.value })}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition"
                  >
                    提交预约申请
                  </button>
                  <p className="text-xs text-gray-400 text-center">提交即表示同意我们的隐私政策，我们不会向第三方分享您的信息。</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">智</span>
                </div>
                <span className="text-white font-bold text-lg">智纬AI</span>
              </div>
              <p className="text-sm leading-relaxed">为中国中小企业提供定制化AI Agent服务，让每个企业都能拥有专属AI团队。</p>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">产品</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#products" className="hover:text-white transition">智小客 AI客服</a></li>
                <li><a href="#products" className="hover:text-white transition">销小帮 AI销售</a></li>
                <li><a href="#products" className="hover:text-white transition">办小助 AI办公</a></li>
                <li><a href="#products" className="hover:text-white transition">全定制服务</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">公司</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:text-white transition">关于我们</a></li>
                <li><a href="#" className="hover:text-white transition">加入我们</a></li>
                <li><a href="#contact" className="hover:text-white transition">联系我们</a></li>
                <li><a href="#" className="hover:text-white transition">博客</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-white font-semibold text-sm mb-3">联系方式</h4>
              <ul className="space-y-2 text-sm">
                <li>📧 contact@westilt.com</li>
                <li>📞 400-888-8888</li>
                <li>📍 中国 · 北京</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm">© 2026 智纬AI westilt.com 版权所有</p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-white transition">隐私政策</a>
              <a href="#" className="hover:text-white transition">服务条款</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
